import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import { Link as RouterLink } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import camera2Outline from '@iconify/icons-eva/camera-outline';
import action20Outline from '@iconify/icons-eva/activity-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@material-ui/core';
import { CustomerType } from './CustomerUtils';
// material

// ----------------------------------------------------------------------

export default function CustomerMoreMenu({
  customerID,
  isAdminUser,
  type,
  onAddActionClick,
  onDeleteClick,
  onViewClick,
  onEditClick,
  onChangeStatusClick
}) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const statusText =
    type === CustomerType.SUSPECT ? `Make ${CustomerType.PROSPECT}` : `Make ${CustomerType.CLIENT}`;
  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {/* <MenuItem
          sx={{ color: 'text.secondary' }}
          onClick={() => {
            setIsOpen(false);
            onViewClick(customerID);
          }}
        >
          <ListItemIcon>
            <Icon icon={camera2Outline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="View" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem> */}
        <MenuItem
          sx={{ color: 'text.secondary' }}
          onClick={() => {
            setIsOpen(false);
            onAddActionClick(customerID);
          }}
        >
          <ListItemIcon>
            <Icon icon={action20Outline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Add Action" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        {isAdminUser && (
          <MenuItem
            sx={{ color: 'text.secondary' }}
            onClick={() => {
              setIsOpen(false);
              onDeleteClick(customerID);
            }}
          >
            <ListItemIcon>
              <Icon icon={trash2Outline} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}

        <MenuItem
          component={RouterLink}
          to="#"
          sx={{ color: 'text.secondary' }}
          onClick={() => {
            setIsOpen(false);
            onEditClick(customerID);
          }}
        >
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        {type !== CustomerType.CLIENT && (
          <MenuItem
            component={RouterLink}
            to="#"
            sx={{ color: 'text.secondary' }}
            onClick={() => {
              setIsOpen(false);
              onChangeStatusClick(customerID, type);
            }}
          >
            <ListItemIcon>
              <Icon icon={camera2Outline} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary={statusText} primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
